import { GrimsbyNotification } from '../context/grimsbyNotifications';

const handleInstructorListNotification = async (
    dispatchPromise: Promise<boolean>,
    addNotification: (notification: GrimsbyNotification) => void,
): Promise<boolean> => {
    const isSuccessful = await dispatchPromise;

    if (!isSuccessful) {
        addNotification({
            id: `update-user-preferences-of-instructor-list-${Date.now()}`,
            type: 'error',
            content:
                'An error occurred while updating the instructors table preferences. Please retry after a while.',
        });
    }

    return isSuccessful;
};

export default handleInstructorListNotification;
